module.exports = __webpack_public_path__ + "img/services.96bebffa.png";